import { ca } from '@cian/analytics';

export const trackSellApartmentClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'Click',
    label: 'Button',
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
    },
    useLastProducts: true,
  });
};
